import { InputAdornment, InputAdornmentProps } from '@mui/material'
import React from 'react'

export type WcInputAdornmentProps = InputAdornmentProps

export const WcInputAdornment = ({children, ...props}: WcInputAdornmentProps) => (
    <InputAdornment {...props}>{children}</InputAdornment>
  )